import { shippingOptionServiceDetails } from '@/constants';
import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { MbeTruck } from '../icons';

interface IShippingOption {
  courier?: string;
  radio?: boolean;
  service: string;
}

export const ShippingOption: React.FC<IShippingOption> = ({
  courier = '',
  radio = false,
  service,
}): JSX.Element => {
  const { t } = useTranslation();

  const shippingOptionService = shippingOptionServiceDetails.get(service);

  return (
    <Flex
      borderColor="black"
      flexDirection={{ base: 'column', md: 'row' }}
      gap={{ base: 4, md: 8 }}
      justifyContent="space-between"
      key={service}
      pl={radio ? 2 : 8}
    >
      <Flex alignItems="center" flexBasis={{ base: 'max-content', md: '800px' }} gap={8} w="full">
        <Icon as={MbeTruck} h={20} w={20} />
        <Box>
          <Text fontSize={{ base: 'h3.base', md: 'h3.md' }} fontWeight="bold">
            {shippingOptionService && `${courier} ${t(shippingOptionService.name)}`}
          </Text>
        </Box>
      </Flex>
      <Text flexGrow={1} maxWidth={{ base: '100%', md: '50%' }}>
        {shippingOptionService && t(shippingOptionService.description)}
      </Text>
    </Flex>
  );
};
